/***
 * 描述：点击头像 锁定系统模态框  
 */
import { Component, OnInit, ViewChild, Output, EventEmitter, Input} from '@angular/core';
import { environment } from 'src/environments/environment';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { GetUserModelService } from 'src/app/librarys/serves/public/get-user-model.service';
import { SwMenuService } from 'src/app/librarys/serves/sw-menu.service';
import {OninitService} from "src/app/librarys/serves/oninit.service";
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import {Md5} from "ts-md5";
import { SystemIdService } from 'src/app/librarys/serves/public/system-id.service';
import { NgForm } from '@angular/forms';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
@Component({
  selector: 'app-sw-lock-system',
  templateUrl: './sw-lock-system.component.html',
  styleUrls: ['./sw-lock-system.component.css']
})
export class SwLockSystemComponent implements OnInit {

  @ViewChild('lockSystemModal') lockSystemModal: SwModalframeComponent; //弹出框组件
  @ViewChild('f') f: NgForm; //弹出框组件

  @Input() param: any;
  @Output() callback = new EventEmitter(); //抛出事件
  invalid: boolean = false; //判断表单保存是否符合条件
  constructor(
    private _http:SwHttpClientService, //请求服务
    private user: GetUserModelService, //获取用户信息
    private Jwt:SwJwtService, //浏览器缓存
    private SwMenus:SwMenuService, //菜单服务
    private init:OninitService, //初始化方法
    private systemId: SystemIdService, 
    private box: SwMassageBoxService,  //消息提示服务

    ) { }
  msg: string = ""; //提示信息
  userModel:any={}; //登入人信息
  loginModel: any = {}; //页面上绑定对象
  ngOnInit() {
    this.userModel = this.user.getUser(); //获取当前登入人 信息
    this.loginModel.loginName = this.userModel.loginName //获取登入人名称
    this.Jwt.setToKen("isLock","true"); //添加新的token,设置锁屏为true
    this.ClickLoca()
  }
  ClickLoca(){
    this.loginModel.loginPassword ="";
    // this.lockSystemModal.toggle(); //打开弹出框
  }

  //提交登入信息
  onSubmit({ value, valid }, event: Event) {
    this.msg = ""; //提示信息 清空
    if (valid) {
               //无验证码的情况下，先获得验证码再加密：
               let pwd = Md5.hashStr(value.loginPassword).toString().toLowerCase();

                let path  = environment.seekerWebAPI + "sw/validPwd";        
                //saas环境下
                if(environment.isSaasLogin){
                  path  = environment.saasWebAPI + "saas/validPwd";     
                }
                    
                   this._http.Post(path,pwd).subscribe(
                    data => {
                     if (data["code"] == 200) {                      
                      this.Jwt.removeItem("isLock"); //清除浏览器缓存数据
                      //this.SwMenus.location(); //菜单初始化
                      //关闭模态框
                      this.lockSystemModal.toggle()
                      //销毁组件
                      this.callback.emit()
                     }else{
                      this.msg = data["msg"];
                     }
                    })
                  // this.entryLogin(path,false)
    }else {
      this.invalid = true;
      this.box.waringError('请输入完整且正确的信息')
    }
  }
}